import React, {useState} from "react";
import "./App.css";
import {KEY, loginState} from "./Constants";
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import {MyFileBrowser} from "./components/Backup/Backup";
import Error404 from "./pages/404/Error404";
import UserList from "./pages/tenantList/UserList";
import Topbar from "./components/topbar/Topbar";
import PropertyList from "./pages/propertyList/PropertyList";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Transactions from "./pages/transactions/Transactions";
import MailList from "./pages/mailsList/MailList";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Analytics from "./pages/analytics/Analytics";
import Expenses from "./pages/Expenses/Expenses";
import {
    NotificationContainer,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import Message from "./pages/messages/Message";
import OldTenantList from "./pages/OldTenantList/OldTenantList";
import Events from "./pages/events/Events";
import Settings from "./pages/settings/Settings";
import Payouts from "./pages/Payouts/Payouts";
import PaymentComplete from "./pages/payment/PaymentComplete";
import TenantIssues from "./pages/tenantIssues/TenantIssues";
import VacatingTenantList from "./pages/vacatingTenantList/VacatingTenantList";
import TestSidebar from "./components/sidebar/TestSidebar";
import CryptoJS from "crypto-js";
import UserManagementV2 from "./pages/AgentUserManagement/UserManagementV2";
import PermissionManagement from "./pages/PermissionManagement/PermissionManagement";
import {ConfirmProvider} from "material-ui-confirm";
import HomeV2 from "./pages/Home/HomeV2";
import TenantV2 from "./pages/tenant/TenantV2";
import {SnackbarComponent} from "./components/SnackBar/SnackBar";
import PropertyV2 from "./pages/property/PropertyV2";
import LoginPageV2 from "./components/authentication/Login/LoginPageV2";
import SignUp from "./pages/signup/SignUp";
import Notifications from "./pages/notifications/Notifications";
import {Box, useMediaQuery} from "@mui/material";
import {ProSidebarProvider} from "react-pro-sidebar";

import {IdleTimeoutProvider} from './components/Idle Session Hook/IdleTimeoutProvider';


const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function App() {
    const isMobile = useMediaQuery("(max-width:800px)");
    const currentPath = window.location.pathname;
    const isLoginPage = currentPath === "/" || currentPath === "/login" || currentPath === "/signup";

    let myMapDetailsDecrypted;
    try {
        myMapDetailsDecrypted = CryptoJS.AES.decrypt(
            localStorage.getItem("myMap"),
            KEY
        );
    } catch (e) {
        myMapDetailsDecrypted = "";
    }

    const logout = () => {
        window.location.href = "/";
        localStorage.clear();
    };

    const [originalText] = React.useState(
        myMapDetailsDecrypted.toString(CryptoJS.enc.Utf8)
    );

    const [open, setOpen] = React.useState(loginState);
    const [backdrop, setBackDrop] = React.useState(null);
    const [message, setMessage] = React.useState("");
    const [severity, setSeverity] = React.useState();
    const [isLoggedIn, setLogin] = React.useState(
        !(
            window.location.pathname === "/" || window.location.pathname === "/signup"
        )
    );

    const changeLogin = () => {
        setLogin(true);
    };

    const [connectionMade, setConnectionMade] = React.useState(false);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(isMobile);

    const handleClick = (message) => {
        setMessage(message.text);
        setSeverity(message.type);
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpen(false);
    };

    const openBackDrop = (message) => {
        if (message === "open") {
            setBackDrop(
                <div
                    style={{
                        position: "absolute",
                    }}
                >
                    <Backdrop
                        sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
                        open={true}
                        onClick={null}
                    >
                        <CircularProgress color="inherit"/>
                    </Backdrop>
                </div>
            );
        } else {
            setBackDrop();
        }
    };

    try {
        new Map(
            JSON.parse(originalText).map((object) => {
                return [object[0], object[1]];
            })
        );
    } catch (e) {
    }

    // SSE
/*
    useEffect(() => {
        const fetchData = async () => {
            try {
                await fetchEventSource(
                    ApiDetails +
                    "pegasus/visionary/sse/" +
                    JSON.parse(originalText)[0][1],
                    {
                        method: "GET",
                        headers: {
                            Accept: "text/event-stream",
                            "Content-Type": "application/json",
                            // token: getAuthToken(), // Uncomment and import getAuthToken when enabling SSE
                        },
                        onopen(res) {
                            if (res.ok && res.status === 200) {
                                setConnectionMade(true);
                            } else if (
                                res.status >= 400 &&
                                res.status < 500 &&
                                res.status !== 429
                            ) {
                                console.log("Client side error ", res);
                            }
                        },
                        onmessage(event) {
                            try {
                                let notifications = Array.from(JSON.parse(event.data));

                                notifications.map((notifi, index) => {
                                    let notification = new Map(Object.entries(notifi));
                                    if (notification.get("type") === "payment") {
                                        NotificationManager.success(
                                            notification.get("tenant_name") +
                                            " Credited " +
                                            notification.get("amount").toLocaleString("en-US", {
                                                style: "currency",
                                                currency: "KSH",
                                            }),
                                            "Payment Received",
                                            3000
                                        );
                                    } else if (
                                        notification.get("type") === "subscription payment"
                                    ) {
                                        NotificationManager.success(
                                            notification.get("message"),
                                            "Subscription",
                                            3000
                                        );
                                        setTimeout(() => {
                                            logout();
                                        }, 3500);
                                    } else if (notification.get("type") === "information") {
                                        NotificationManager.info(
                                            notification.get("message"),
                                            "Notice",
                                            3000
                                        );
                                    } else if (notification.get("type") === "warning") {
                                        NotificationManager.warning(
                                            notification.get("message"),
                                            "Warning",
                                            3000
                                        );
                                    } else if (notification.get("type") === "error") {
                                        NotificationManager.error(
                                            notification.get("message"),
                                            "Error",
                                            3000
                                        );
                                    }
                                });
                            } catch (e) {
                            }
                        },
                        onclose() {
                            console.log("Connection closed by the server retrying ... ");
                        },
                        onerror(err) {
                            console.log("There was an error from server", err);
                        },
                    }
                );
            } catch (e) {
            }
        };
        if (!connectionMade) {
            fetchData();
        }
    }, []);
*/

    const [sidebarOpen, setSidebarOpen] = useState(!isMobile);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
        setSidebarCollapsed(!sidebarCollapsed);
    };

    const {render, setForceRefresh} = Topbar(toggleSidebar);

    // Handle sidebar collapse state
    const handleSidebarCollapse = (collapsed) => {
        setSidebarCollapsed(collapsed);
    };

    // Calculate main content margin based on sidebar state and mobile
    const contentMargin = isMobile
        ? "0px"
        : sidebarCollapsed
            ? "70px"
            : "250px";

    return (

        <IdleTimeoutProvider
            onLogout={logout}
            timeoutDuration={30 * 60 * 1000} // 30 minutes total
            promptDuration={5 * 60 * 1000}   // 5 minute warning in milliseconds
            enabled={!isLoginPage} // Disable on login, signup, and root pages
        >

            <ConfirmProvider>
                <div>
                    <SnackbarComponent/>
                    <NotificationContainer/>

                    <Stack spacing={2} sx={{width: "100%"}}>
                        <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                            <Alert
                                onClose={handleClose}
                                severity={severity}
                                sx={{width: "100%"}}
                            >
                                {message}
                            </Alert>
                        </Snackbar>
                    </Stack>
                    {backdrop}
                    <div className="App">
                        <Router>
                            <Box className="app-container" sx={{position: "relative", zIndex: 0}}>
                                {/* Sidebar Section */}
                                {isLoggedIn && !["/", "/signup"].includes(window.location.pathname) && (
                                    <ProSidebarProvider>
                                        <Box
                                            sx={{
                                                position: "fixed",
                                                height: "100vh",
                                                left: 0,
                                                top: 0,
                                                bottom: 0,
                                                zIndex: 10000,
                                                flexShrink: 0,
                                                // display: isMobile ? (sidebarOpen ? "block" : "none") : "block",
                                                display: "block",
                                            }}
                                        >
                                            <TestSidebar
                                                sidebarOpen={sidebarOpen}
                                                setSidebarOpen={setSidebarOpen}
                                                onCollapse={handleSidebarCollapse}
                                            />
                                        </Box>
                                    </ProSidebarProvider>
                                )}

                                {/* Main Content Wrapper */}
                                <Box
                                    sx={{
                                        width: "100%",
                                        marginLeft: isLoggedIn && !["/", "/signup"].includes(window.location.pathname)
                                            ? contentMargin
                                            : "0",
                                        transition: "margin-left 0.3s ease",
                                        backgroundColor: "#F5F5F5",
                                        zIndex: 1100,
                                        position: "relative",
                                        flexGrow: 1,
                                    }}
                                >
                                    {/* Topbar */}
                                    {isLoggedIn && <>{render}</>}

                                    {/* Routes */}
                                    <Box
                                        sx={{
                                            px: 2,
                                            pb: 0,
                                            pt: isLoginPage ? 0 : "84px",
                                            mt: 0,
                                        }}
                                    >
                                        <Routes>
                                            <Route
                                                path="/"
                                                element={
                                                    <LoginPageV2
                                                        snackBar={(message) => {
                                                            handleClick(message);
                                                        }}
                                                        fn={() => changeLogin()}
                                                        topBar={() => changeLogin()}
                                                        refresh={(value) => {
                                                            setForceRefresh(value);
                                                        }}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/userManagement"
                                                element={
                                                    <UserManagementV2
                                                        snackBar={(message) => {
                                                            handleClick(message);
                                                        }}
                                                        fn={() => changeLogin()}
                                                        topBar={() => changeLogin()}
                                                        refresh={(value) => {
                                                            setForceRefresh(value);
                                                        }}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/user-management/:subUserId/permissions"
                                                element={<PermissionManagement />}
                                            />
                                            <Route
                                                path="/login"
                                                element={
                                                    <LoginPageV2
                                                        snackBar={(message) => {
                                                            handleClick(message);
                                                        }}
                                                        fn={() => changeLogin()}
                                                        topBar={() => changeLogin()}
                                                        refresh={(value) => {
                                                            setForceRefresh(value);
                                                        }}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/tenantList"
                                                element={
                                                    <UserList
                                                        refreshSideBar={() =>
                                                            setForceRefresh((forceRefresh) => !forceRefresh)
                                                        }
                                                        loginState={isLoggedIn}
                                                        snackBar={(message) => handleClick(message)}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/vacatingTenantList"
                                                element={
                                                    <VacatingTenantList
                                                        refreshSideBar={() =>
                                                            setForceRefresh((forceRefresh) => !forceRefresh)
                                                        }
                                                        loginState={isLoggedIn}
                                                        snackBar={(message) => handleClick(message)}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/tenantIssues"
                                                element={
                                                    <TenantIssues
                                                        refreshSideBar={() =>
                                                            setForceRefresh((forceRefresh) => !forceRefresh)
                                                        }
                                                        loginState={isLoggedIn}
                                                        snackBar={(message) => handleClick(message)}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/oldTenantList"
                                                element={
                                                    <OldTenantList
                                                        refreshSideBar={() =>
                                                            setForceRefresh((forceRefresh) => !forceRefresh)
                                                        }
                                                        loginState={isLoggedIn}
                                                        snackBar={(message) => handleClick(message)}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/analytics"
                                                element={
                                                    <Analytics
                                                        refreshSideBar={() =>
                                                            setForceRefresh((forceRefresh) => !forceRefresh)
                                                        }
                                                        loginState={isLoggedIn}
                                                        snackBar={(message) => handleClick(message)}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/propertyList"
                                                element={
                                                    <PropertyList
                                                        refreshSideBar={() =>
                                                            setForceRefresh((forceRefresh) => !forceRefresh)
                                                        }
                                                        snackBar={(message) => handleClick(message)}
                                                        loginState={isLoggedIn}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/transactions"
                                                element={
                                                    <Transactions
                                                        refreshSideBar={() =>
                                                            setForceRefresh((forceRefresh) => !forceRefresh)
                                                        }
                                                        snackBar={(message) => handleClick(message)}
                                                        loginState={isLoggedIn}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/signup"
                                                element={
                                                    <SignUp
                                                        snackBar={(message) => handleClick(message)}
                                                        fn={() => changeLogin()}
                                                        topBar={() => changeLogin()}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/tenant/:userId"
                                                element={
                                                    <TenantV2
                                                        loginState={isLoggedIn}
                                                        snackBar={(message) => handleClick(message)}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/property/:propertyId"
                                                element={
                                                    <PropertyV2
                                                        loginState={isLoggedIn}
                                                        snackBar={(message) => handleClick(message)}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/mailList"
                                                element={
                                                    <MailList
                                                        loginState={isLoggedIn}
                                                        snackBar={(message) => handleClick(message)}
                                                        backrop={(message) => {
                                                            openBackDrop(message);
                                                        }}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/messages"
                                                element={
                                                    <Message
                                                        refreshSideBar={() =>
                                                            setForceRefresh((forceRefresh) => !forceRefresh)
                                                        }
                                                        snackBar={(message) => handleClick(message)}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/expenses"
                                                element={
                                                    <Expenses
                                                        refreshSideBar={() =>
                                                            setForceRefresh((forceRefresh) => !forceRefresh)
                                                        }
                                                        loginState={isLoggedIn}
                                                        snackBar={(message) => handleClick(message)}
                                                        backrop={(message) => {
                                                            openBackDrop(message);
                                                        }}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/payouts"
                                                element={
                                                    <Payouts
                                                        refreshSideBar={() =>
                                                            setForceRefresh((forceRefresh) => !forceRefresh)
                                                        }
                                                        loginState={isLoggedIn}
                                                        snackBar={(message) => handleClick(message)}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/home"
                                                element={
                                                    <HomeV2
                                                        refreshSideBar={() =>
                                                            setForceRefresh((forceRefresh) => !forceRefresh)
                                                        }
                                                        fn={() => changeLogin()}
                                                        loginState={isLoggedIn}
                                                        topBar={() => changeLogin()}
                                                        snackBar={(message) => handleClick(message)}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/events"
                                                element={
                                                    <Events
                                                        refreshSideBar={() =>
                                                            setForceRefresh((forceRefresh) => !forceRefresh)
                                                        }
                                                        loginState={isLoggedIn}
                                                        topBar={() => changeLogin()}
                                                        snackBar={(message) => handleClick(message)}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/settings"
                                                element={
                                                    <Settings
                                                        refreshSideBar={() =>
                                                            setForceRefresh((forceRefresh) => !forceRefresh)
                                                        }
                                                        refresh={(value) => {
                                                            setForceRefresh(value);
                                                        }}
                                                        snackBar={(message) => handleClick(message)}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/notifications"
                                                element={
                                                    <Notifications
                                                        snackBar={(message) => handleClick(message)}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/payment/complete"
                                                element={
                                                    <PaymentComplete
                                                        snackBar={(message) => handleClick(message)}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/backup"
                                                element={
                                                    <MyFileBrowser
                                                        snackBar={(message) => handleClick(message)}
                                                        topBar={(value) => changeLogin(value)}
                                                    />
                                                }
                                            />
                                            <Route
                                                path="*"
                                                element={
                                                    <Error404
                                                        snackBar={(message) => {
                                                            handleClick(message);
                                                        }}
                                                        fn={() => changeLogin()}
                                                        topBar={() => changeLogin()}
                                                        refresh={(value) => {
                                                            setForceRefresh(value);
                                                        }}
                                                    />
                                                }
                                            />
                                        </Routes>
                                    </Box>
                                </Box>
                            </Box>
                        </Router>
                    </div>
                </div>
            </ConfirmProvider>
        </IdleTimeoutProvider>
    );
}

export default App;